import merge from 'lodash/merge';

import { createDashHttpClient } from '@/apis/dash.http';
import { env } from '@/env';

export const camelCaseHttp = createDashHttpClient(env.threadsApiUrl, {
  camelizeKeys: true,
});
export const http = createDashHttpClient(env.threadsApiUrl);

export async function getThreadsProfile({ brandId }, config = {}) {
  return camelCaseHttp.get(`/brands/${brandId}/profile`, config);
}

export async function getThreadsProfileAllBrands({ brandIds }, config = {}) {
  return camelCaseHttp.put(`/brands/profiles`, { brand_ids: brandIds }, config);
}

export async function getThreadsFollowerDemographics({ brandId, date }, config = {}) {
  return http.get(
    `/brands/${brandId}/profile/follower_demographic_insights`,
    merge(
      {
        params: { date },
      },
      config,
    ),
  );
}

export async function postThreadsDemographicsInsightsCSV(
  { brandId, date, socketId, breakdown },
  config = {},
) {
  return http.post(
    `/brands/${brandId}/profile/follower_demographic_insights/csv`,
    { date, socketId, breakdown },
    config,
  );
}
